var React = require('react');

function Chap6 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M124.27,26.31A49.52,49.52,0,0,1,146,88.44l24.89,12.72A77.41,77.41,0,0,0,137,1.49Z","style":{"fill":"none","stroke":"#1c3b40","strokeMiterlimit":"10"},"key":0}),React.createElement("path",{"d":"M35.32,51.32a49.56,49.56,0,0,1,62.53-19L110.53,7.46A77.39,77.39,0,0,0,10.44,38.61Z","style":{"fill":"#1c3b40"},"key":1}),React.createElement("path",{"d":"M56.43,122.27,43.75,147.09a77.4,77.4,0,0,0,102.61-34.46L121.55,100A49.54,49.54,0,0,1,56.43,122.27Z","style":{"fill":"#a5b2a6"},"key":2}),React.createElement("path",{"d":"M52.82,120.41A49.54,49.54,0,0,1,33.31,54.87L8.49,42.19a77.39,77.39,0,0,0,31.65,103Z","style":{"fill":"#a5c4c6"},"key":3})]);
}

Chap6.defaultProps = {"viewBox":"0 0 178.15 154.82"};

module.exports = Chap6;

Chap6.default = Chap6;
